/* eslint camelcase: ["error", {properties: "never"}] */
var release = true;

var _config;

if (release) {
  _config = {
    logoPath: '//i.gtimg.cn/qqlive/images/20160606/i1465201597_1.jpg',
    // 统一登录页面上方logo图片
    appid: '532001604',
    // 统一登录页面appid
    defaultAvtarImg: '//imgcache.qq.com/mediastyle/tenvideo/img/film/global/default_avatar.png',
    // 默认QQ头像
    defaultWeiXinImg: '//i.gtimg.cn/qqlive/images/20140801/wx.jpg',
    // 默认微信头像
    payPath: '//imgcache.gtimg.cn/bossweb/h5pay/js/api/mcash.js',
    // pay移动端h5支付js api文件路径
    // 正式环境
    openid_cookie: 'hlw_wx_openid',
    // 用户openid的cookie
    token_cookie: 'hlw_wx_token',
    // 用户accesstoken的cookie
    nickname_cookie: 'hlw_wx_nickname',
    // 用户昵称
    face_cookie: 'hlw_wx_face',
    // 用户头像
    bindqq_cookie: 'hlw_wx_bindqq',
    // 绑定qq号的cookie
    bindtype_cookie: 'hlw_wx_otype',
    // 绑定操作类型的cookie
    oauth_cookie: 'hlw_wx_oauth',
    // 标识是否进行过鉴权
    wxappid: 'wx68ff4e3ba9f84df4',
    // 公共号appid
    baseUrl: '//film.qq.com',
    // 基础url
    payCgiBaseUrl: '//pay.video.qq.com/fcgi-bin/',
    graphCgiBaseUrl: 'https://graph.qq.com/v3/video/',
    bookcgi: '//sns.video.qq.com/fcgi-bin/liveportal/follow?otype=json' // 预定cgi

  };
} else {
  _config = {
    logoPath: '//i.gtimg.cn/qqlive/images/20160606/i1465201597_1.jpg',
    // 统一登录页面上方logo图片
    appid: '532001604',
    // 统一登录页面appid
    defaultAvtarImg: '//imgcache.qq.com/mediastyle/tenvideo/img/film/global/default_avatar.png',
    // 默认头像
    payPath: '//imgcache.gtimg.cn/bossweb/h5pay/js/api/mcash.js',
    // pay移动端h5支付js api文件路径
    // 测试环境
    openid_cookie: 'hlw_wx_openid_test',
    // 用户openid的cookie
    token_cookie: 'hlw_wx_token_test',
    // 用户accesstoken的cookie
    nickname_cookie: 'hlw_wx_nickname_test',
    // 用户昵称
    face_cookie: 'hlw_wx_face_test',
    // 用户头像
    bindqq_cookie: 'hlw_wx_bindqq_test',
    // 绑定qq号的cookie
    bindtype_cookie: 'hlw_wx_otype_test',
    // 绑定操作类型的cookie
    oauth_cookie: 'hlw_wx_oauth_test',
    // 标识是否进行过鉴权
    wxappid: 'wxce4e76ba46314691',
    // 公共号appid
    baseUrl: '//p30.video.qq.com',
    // 基础url
    // bookcgi: "//p30.video.qq.com/fcgi-bin/nbook?otype=json", // 预定cgi
    bookcgi: '//sns.video.qq.com/fcgi-bin/liveportal/follow?otype=json',
    // 预定cgi
    payCgiBaseUrl: '//p30.video.qq.com/fcgi-bin/',
    graphCgiBaseUrl: 'https://119.147.19.43/v3/video/'
  };
}

_config.release = release;
var config = _config;
export default config;